import React from 'react';
import { Chip, type ChipColorTypes } from '@saviynt/design-system';

import { useInvertedLocalize } from '../../hooks';

type SeverityLevel =
  | 'very high'
  | 'high'
  | 'medium'
  | 'low'
  | 'very low'
  | 'none';

const SEVERITY_MAP = {
  'very high': { text: 'Very High', color: 'pink' },
  high: { text: 'High', color: 'orange' },
  medium: { text: 'Medium', color: 'warning' },
  low: { text: 'Low', color: 'brandSecondary' },
  'very low': { text: 'Very Low', color: 'success' },
  none: { text: 'None', color: 'neutral' },
} satisfies Record<SeverityLevel, { text: string; color: ChipColorTypes }>;

interface SodSeverityChipProps {
  text: string;
}

/**
 * For Severity chip
 */
function SodSeverityChip({ text }: SodSeverityChipProps) {
  const l = useInvertedLocalize();

  if (!text || !Object.keys(SEVERITY_MAP).includes(text.toLowerCase())) {
    return null;
  }

  const { text: label, color } =
    SEVERITY_MAP[text.toLowerCase() as SeverityLevel];

  return <Chip size='xSmall' kind='outlined' label={l(label)} color={color} />;
}

export default SodSeverityChip;
